import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_154_branch_summary: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Branches",
    style: {},
    fabAction: {
      type: "add",
      screenId: "170",
      action: "modulev1/branch_add",
    },
    childComponents: [
      {
        componentType: ComponentType.SUMMARY_LIST,
        Name: "branch_summary",
        BindValue: "grid_emp",
        titleValue: "Branches", // Not explicitly in JSON but good practice for SummaryList
        SummeryActions: [
          {
            Action: {
              Action: "Navigate",
              Navigate: "modulev1/branch_add/<id>",
            },
            ActionType: "Edit",
            ScreenId: "170",
          },
          {
            Action: {
              Action: "Delete",
              Module: "branch_summary",
            },
            ActionType: "Delete",
            ScreenId: "170",
          },
        ],
        Form: {
          Name: "branch_summary",
          TableName: "branches",
          DisplayName: "Branches",
          Fields: [
            {
              IncludeLabel: true,
              Label: "id",
              BindValue: "id",
              Json_Attribute: "id",
              showInSummary: false,
              IsPrimary: true,
            },
            {
              IncludeLabel: true,
              Label: "Name",
              BindValue: "name",
              Json_Attribute: "name",
              showInSummary: true, // User requested correction
              IsPrimary: false,
            },
            {
              IncludeLabel: true,
              Label: "Mobile",
              BindValue: "txt_mobile",
              Json_Attribute: "mobile",
              showInSummary: true, // User requested correction mobile
              IsPrimary: false,
            },
          ],
        },
      },
    ],
  },
];
